import React from "react";
import { ShoppingItem } from "../hooks/useShoppingList";
import { useLanguage } from "../../src/utils/useLanguage";
import { UI_STRINGS } from "../utils/translations";
import {
  CheckedItemsContainer,
  CheckedItemsTitle,
  CheckedItemsList,
  CheckedItem,
  CheckedItemName,
  RemoveAllButton,
} from "../Pages/ShoppingList.style";

interface CheckedItemsProps {
  items: ShoppingItem[];
  onUncheckItem: (item: ShoppingItem) => void;
  onRemoveItem: (itemId: string) => void;
  onRemoveAll: () => void;
}

export const CheckedItems: React.FC<CheckedItemsProps> = ({
  items,
  onUncheckItem,
  onRemoveItem,
  onRemoveAll,
}) => {
  const { language } = useLanguage();
  return (
    <CheckedItemsContainer>
      <CheckedItemsList>
        <CheckedItemsTitle>
          {UI_STRINGS[language].checkedItems}
        </CheckedItemsTitle>
        {items.map((item) => (
          <CheckedItem
            key={item.id}
            title={UI_STRINGS[language].clickToBringBack}
            onClick={() => onUncheckItem(item)}
          >
            <CheckedItemName>{item.name}</CheckedItemName>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onRemoveItem(item.id);
              }}
              title={UI_STRINGS[language].removeItem}
            >
              X
            </button>
          </CheckedItem>
        ))}
        {items.length > 4 && (
          <RemoveAllButton onClick={onRemoveAll}>
            {UI_STRINGS[language].removeAllItems}
          </RemoveAllButton>
        )}
      </CheckedItemsList>
    </CheckedItemsContainer>
  );
};
